import {
  getFeatureFlags,
  getPermissionUtils,
  getPersonalSettings,
  getUser,
} from '@tyro/api';
import type { HasAccessFunction } from '../@types/nav-object';

export async function checkHasAccess(
  hasAccess: HasAccessFunction,
  throwError = true,
) {
  try {
    const [permissions, featureFlags, user, personalSettings] =
      await Promise.all([
        getPermissionUtils(),
        getFeatureFlags(),
        getUser(),
        getPersonalSettings(),
      ]);
    if (!hasAccess({ permissions, featureFlags, ...user, personalSettings })) {
      if (throwError) {
        throw new Response('Forbidden', { status: 403 });
      }

      return false;
    }

    return true;
  } catch (error) {
    if (throwError) {
      throw error;
    }

    return false;
  }
}
